import React from 'react';
import logoBlack from '@/assets/images/logo.svg';
import logoWhite from '@/assets/images/logo-white.png';
import { ImageProps, Image } from '@chakra-ui/react';
export interface LogoProps {
  color: 'white' | 'black';
  w: ImageProps['w'];
  h: ImageProps['h'];
}

export const Logo: React.FC<LogoProps> = ({ color, ...props }) => {
  const logo = color === 'black' ? logoBlack : logoWhite;
  return <Image alt="Pretia logo" src={logo} {...props} />;
};
